(() => {
  const initSlider = (root) => {
    if (root.dataset.shPreOrderReady === 'true') return;
    root.dataset.shPreOrderReady = 'true';

    const track = root.querySelector('.sh-pre-order-products__track');
    const dotsWrap = root.querySelector('[data-sh-pre-order-dots]');
    if (!track || !dotsWrap) return;

    const dots = Array.from(dotsWrap.querySelectorAll('.sh-pre-order-products__dot'));
    const items = Array.from(track.querySelectorAll('.sh-pre-order-products__item'));
    const pageCount = Math.max(
      1,
      Number(root.getAttribute('data-page-count') || dots.length || 1)
    );
    if (!items.length || !dots.length) return;

    const setActive = (index) => {
      const safeIndex = Math.max(0, Math.min(index, pageCount - 1));
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === safeIndex);
      });
    };

    const getPageScrollLeft = (pageIndex) => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      if (pageCount <= 1 || maxScroll <= 1) return 0;
      return (maxScroll / (pageCount - 1)) * pageIndex;
    };

    const getActiveIndex = () => {
      const scrollLeft = track.scrollLeft;
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 1 || pageCount <= 1) return 0;
      if (scrollLeft >= maxScroll - 2) return pageCount - 1;

      const ratio = scrollLeft / maxScroll;
      return Math.round(ratio * (pageCount - 1));
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.getAttribute('data-index') || 0);
        track.scrollTo({ left: getPageScrollLeft(index), behavior: 'smooth' });
        setActive(index);
      });
    });

    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        setActive(getActiveIndex());
        ticking = false;
      });
    }, { passive: true });

    setActive(0);
  };

  const refreshCarousel = (carousel) => {
    if (!carousel) return;
    if (typeof carousel.refresh === 'function') {
      carousel.refresh();
      return;
    }
    if (typeof carousel.init === 'function' && !carousel.hasAttribute('loaded')) {
      carousel.init();
    }
  };

  const getMainTrack = (modal) => {
    const mainSlider = modal.querySelector('[data-sh-pre-order-qv-main-slider]');
    return mainSlider ? mainSlider.querySelector('.slider') : null;
  };

  const getMainSlides = (modal) => Array.from(
    modal.querySelectorAll('[data-sh-pre-order-qv-main-slider] .slider__item')
  );

  const getThumbSlides = (modal) => Array.from(
    modal.querySelectorAll('[data-sh-pre-order-qv-thumbs] .slider__item')
  );

  const getClosestSlideIndex = (track, slides) => {
    if (!track || !slides.length) return 0;
    const scrollLeft = track.scrollLeft;
    let closestIndex = 0;
    let closestDistance = Infinity;

    slides.forEach((slide, index) => {
      const distance = Math.abs(slide.offsetLeft - scrollLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  };

  const syncActiveClasses = (modal, mediaId) => {
    const strMediaId = String(mediaId);

    getMainSlides(modal).forEach((item) => {
      item.classList.toggle('is-active', String(item.dataset.mediaId) === strMediaId);
    });

    getThumbSlides(modal).forEach((item) => {
      item.classList.toggle('is-active', String(item.dataset.mediaId) === strMediaId);
    });
  };

  const scrollThumbIntoView = (modal, mediaId) => {
    const thumbSlider = modal.querySelector('[data-sh-pre-order-qv-thumbs]');
    const thumbSlide = modal.querySelector(
      `[data-sh-pre-order-qv-thumbs] .slider__item[data-media-id="${mediaId}"]`
    );
    const thumbTrack = thumbSlider ? thumbSlider.querySelector('.slider') : null;
    if (!thumbTrack || !thumbSlide) return;

    const maxScroll = Math.max(0, thumbTrack.scrollWidth - thumbTrack.clientWidth);
    const target = thumbSlide.offsetLeft - (thumbTrack.clientWidth - thumbSlide.clientWidth) / 2;
    const left = Math.max(0, Math.min(target, maxScroll));
    thumbTrack.scrollTo({ left, behavior: 'smooth' });
  };

  const goToMedia = (modal, mediaId, { scrollMain = true, behavior = 'smooth' } = {}) => {
    if (!modal || mediaId == null) return;
    const strMediaId = String(mediaId);
    const track = getMainTrack(modal);
    const mainSlide = modal.querySelector(
      `[data-sh-pre-order-qv-main-slider] .slider__item[data-media-id="${strMediaId}"]`
    );

    modal._shQvLockMediaId = strMediaId;

    if (scrollMain && track && mainSlide) {
      track.scrollTo({ left: mainSlide.offsetLeft, behavior });
    }

    syncActiveClasses(modal, strMediaId);
    scrollThumbIntoView(modal, strMediaId);

    window.clearTimeout(modal._shQvLockTimer);
    modal._shQvLockTimer = window.setTimeout(() => {
      if (modal._shQvLockMediaId === strMediaId) {
        modal._shQvLockMediaId = null;
      }
    }, behavior === 'smooth' ? 450 : 50);
  };

  const syncFromMainScroll = (modal) => {
    if (modal._shQvLockMediaId) {
      syncActiveClasses(modal, modal._shQvLockMediaId);
      return;
    }

    const track = getMainTrack(modal);
    const slides = getMainSlides(modal);
    const index = getClosestSlideIndex(track, slides);
    const mediaId = slides[index] && slides[index].dataset.mediaId;
    if (!mediaId) return;

    syncActiveClasses(modal, mediaId);
    scrollThumbIntoView(modal, mediaId);
  };

  const resetGalleryToFirst = (modal) => {
    const firstSlide = getMainSlides(modal)[0];
    if (!firstSlide) return;
    goToMedia(modal, firstSlide.dataset.mediaId, { scrollMain: true, behavior: 'auto' });
  };

  const initQuickviewGallery = (modal) => {
    if (!modal || modal.dataset.shQvGalleryReady === 'true') return;
    modal.dataset.shQvGalleryReady = 'true';

    const mainSlider = modal.querySelector('[data-sh-pre-order-qv-main-slider]');
    const thumbSlider = modal.querySelector('[data-sh-pre-order-qv-thumbs]');
    const mainTrack = getMainTrack(modal);

    refreshCarousel(mainSlider);
    refreshCarousel(thumbSlider);

    if (mainTrack) {
      let ticking = false;
      mainTrack.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          syncFromMainScroll(modal);
          ticking = false;
        });
      }, { passive: true });
    }

    modal.querySelectorAll('[data-sh-pre-order-qv-thumbs] .thumbnail').forEach((thumb) => {
      thumb.addEventListener('click', (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        const item = thumb.closest('.slider__item');
        const mediaId = item && item.dataset.mediaId;
        if (!mediaId) return;
        goToMedia(modal, mediaId, { scrollMain: true, behavior: 'smooth' });
      });
    });
  };

  const prepareQuickviewOpen = (modal) => {
    if (!modal) return;
    initQuickviewGallery(modal);

    const mainSlider = modal.querySelector('[data-sh-pre-order-qv-main-slider]');
    const thumbSlider = modal.querySelector('[data-sh-pre-order-qv-thumbs]');

    requestAnimationFrame(() => {
      refreshCarousel(mainSlider);
      refreshCarousel(thumbSlider);
      resetGalleryToFirst(modal);

      requestAnimationFrame(() => {
        refreshCarousel(mainSlider);
        refreshCarousel(thumbSlider);
        resetGalleryToFirst(modal);
      });
    });
  };

  const initQuickviewOpeners = () => {
    document.querySelectorAll('[data-sh-pre-order-qv-open]').forEach((btn) => {
      if (btn.dataset.shQvBound === 'true') return;
      btn.dataset.shQvBound = 'true';

      btn.addEventListener('click', () => {
        const modalId = btn.getAttribute('data-sh-pre-order-qv-open');
        if (!modalId) return;
        const modal = document.getElementById(modalId);
        if (!modal || typeof modal.open !== 'function') return;
        prepareQuickviewOpen(modal);
        modal.open(btn);
      });
    });
  };

  /* ------------------------------------------------------------------ FOMO */

  let fomoTimer = null;
  let fomoTick = 0;

  const interpolate = (row, now) => {
    const startValue = Number(row.dataset.startValue);
    const endValue = Number(row.dataset.endValue);
    const startTs = Number(row.dataset.startTs) * 1000;
    const endTs = Number(row.dataset.endTs) * 1000;

    if (!Number.isFinite(startValue) || !Number.isFinite(endValue)) return null;
    if (!startTs || !endTs || endTs <= startTs) return startValue;
    if (now <= startTs) return startValue;
    if (now >= endTs) return endValue;

    const ratio = (now - startTs) / (endTs - startTs);
    return startValue + (endValue - startValue) * ratio;
  };

  const updateFomoBar = (row, now) => {
    const raw = interpolate(row, now);
    if (raw === null) return;

    const total = Number(row.dataset.total) || 0;
    let current;
    let totalText;
    let width;
    let value;

    if (row.dataset.mode === 'absolute') {
      value = Math.max(0, Math.floor(raw));
      current = String(value);
      totalText = total > 0 ? '/' + total : '';
      width = total > 0 ? (value / total) * 100 : 0;
    } else {
      const tenths = Math.max(0, Math.floor(raw * 10));
      const whole = Math.floor(tenths / 10);
      const frac = tenths % 10;
      value = whole;
      current = frac > 0 ? whole + ',' + frac + '%' : whole + '%';
      totalText = '';
      width = tenths / 10;
    }

    width = Math.max(0, Math.min(100, width));

    const currentEl = row.querySelector('[data-sh-fomo-current]');
    if (currentEl && currentEl.textContent !== current) currentEl.textContent = current;

    const totalEl = row.querySelector('[data-sh-fomo-total]');
    if (totalEl && totalEl.textContent !== totalText) totalEl.textContent = totalText;

    const fill = row.querySelector('.sh-pre-order-fomo__bar-fill');
    if (fill) fill.style.width = width + '%';

    row.setAttribute('aria-valuenow', String(value));

    const lowMax = Number(row.dataset.lowMax);
    const midMax = Number(row.dataset.midMax);
    let color = row.dataset.colorMid;
    if (Number.isFinite(lowMax) && value <= lowMax) {
      color = row.dataset.colorLow;
    } else if (Number.isFinite(midMax) && value > midMax) {
      color = row.dataset.colorHigh;
    }

    const host = row.closest('.sh-pre-order-fomo');
    if (host && color) host.style.setProperty('--sh-po-fomo-accent', color);
  };

  const updateFomoCountdown = (el, now) => {
    const endTs = Number(el.dataset.endTs) * 1000;
    const remaining = Math.floor((endTs - now) / 1000);

    if (!Number.isFinite(endTs) || remaining <= 0) {
      el.hidden = true;
      return;
    }

    el.hidden = false;

    const labels = (el.dataset.labels || 'D|H|M|S').split('|');
    const days = Math.floor(remaining / 86400);
    const hours = Math.floor((remaining % 86400) / 3600);
    const minutes = Math.floor((remaining % 3600) / 60);
    const seconds = remaining % 60;

    const timeEl = el.querySelector('[data-sh-fomo-countdown-time]');
    if (!timeEl) return;

    const next = [
      days + (labels[0] || ''),
      hours + (labels[1] || ''),
      minutes + (labels[2] || ''),
      seconds + (labels[3] || '')
    ].join(' : ');

    if (timeEl.textContent !== next) timeEl.textContent = next;
  };

  const initFomo = () => {
    if (fomoTimer) {
      window.clearInterval(fomoTimer);
      fomoTimer = null;
    }

    const countdowns = Array.from(document.querySelectorAll('[data-sh-fomo-countdown]'));
    const bars = Array.from(document.querySelectorAll('[data-sh-fomo-bar]'));
    if (!countdowns.length && !bars.length) return;

    fomoTick = 0;

    const run = () => {
      const now = Date.now();
      countdowns.forEach((el) => updateFomoCountdown(el, now));
      if (fomoTick % 10 === 0) bars.forEach((row) => updateFomoBar(row, now));
      fomoTick += 1;
    };

    run();
    if (!countdowns.length && !bars.length) return;
    fomoTimer = window.setInterval(run, 1000);
  };

  const boot = () => {
    document.querySelectorAll('[data-sh-pre-order-slider]').forEach((root) => {
      root.dataset.shPreOrderReady = 'false';
      initSlider(root);
    });
    initQuickviewOpeners();
    initFomo();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

  document.addEventListener('sh:pre-order:bind', () => {
    document.querySelectorAll('[data-sh-pre-order-slider]').forEach((root) => {
      initSlider(root);
    });
    initQuickviewOpeners();
  });

  document.addEventListener('sh:lfu:qv-open', (event) => {
    const modal = event.detail && event.detail.modal;
    const opener = event.detail && event.detail.opener;
    if (!modal || typeof modal.open !== 'function') return;
    prepareQuickviewOpen(modal);
    modal.open(opener);
  });
})();
